<div *ngFor="let x of [].constructor(numberOfCells); let i = index" 
     [attr.data-index]="i" 
     class="volume-cell grey">
</div>
